// TODO: rename these to update clients
export const GET_ADMIN_USERS = "GET_ADMIN_USERS";
export const GET_ADMIN_USERS_SUCCESS = "GET_ADMIN_USERS_SUCCESS";
export const GET_ADMIN_USERS_ERROR = "GET_ADMIN_USERS_ERROR";

export const GET_REGISTRATION_PENDING_USERS = "GET_REGISTRATION_PENDING_USERS"
export const GET_REGISTRATION_PENDING_USERS_SUCCESS = "GET_REGISTRATION_PENDING_USERS_SUCCESS"
export const GET_REGISTRATION_PENDING_USERS_ERROR = "GET_REGISTRATION_PENDING_USERS_ERROR"

export const GET_OLD_ADMIN_USERS = "GET_OLD_ADMIN_USERS";
export const GET_OLD_ADMIN_USERS_SUCCESS = "GET_OLD_ADMIN_USERS_SUCCESS";
export const GET_OLD_ADMIN_USERS_ERROR = "GET_OLD_ADMIN_USERS_ERROR";

export const UPDATE_CLIENTS = "UPDATE_CLIENTS";
export const UPDATE_CLIENTS_SUCCESS = "UPDATE_CLIENTS_SUCCESS";
export const UPDATE_CLIENTS_ERROR = "UPDATE_CLIENTS_ERROR";

export const GET_CLIENT_USERS_BY_ACCOUNT_ID = "GET_CLIENT_USERS_BY_ACCOUNT_ID";
export const GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS = "GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS";
export const GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR = "GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR";
export const RESET_LAST_COMPLETED_ACTION = "RESET_LAST_COMPLETED_ACTION"


export const GET_CURRENT_ACCOUNT_USERS = "GET_CURRENT_ACCOUNT_USERS";
export const GET_CURRENT_ACCOUNT_USERS_SUCCESS = "GET_CURRENT_ACCOUNT_USERS_SUCCESS";
export const GET_CURRENT_ACCOUNT_USERS_ERROR = "GET_CURRENT_ACCOUNT_USERS_ERROR";

export const CREATE_ADMIN_RECENT_VISIT = "CREATE_ADMIN_RECENT_VISIT";
export const CREATE_ADMIN_RECENT_VISIT_SUCCESS = "CREATE_ADMIN_RECENT_VISIT_SUCCESS";
export const CREATE_ADMIN_RECENT_VISIT_ERROR = "CREATE_ADMIN_RECENT_VISIT_ERROR";

export const GET_ADMIN_RECENT_VISIT = "GET_ADMIN_RECENT_VISIT";
export const GET_ADMIN_RECENT_VISIT_SUCCESS = "GET_ADMIN_RECENT_VISIT_SUCCESS";
export const GET_ADMIN_RECENT_VISIT_ERROR = "GET_ADMIN_RECENT_VISIT_ERROR";

export const SEND_ADMIN_CLIENT_INVITE_MAIL = "SEND_ADMIN_CLIENT_INVITE_MAIL"
export const SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS = "SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS"
export const SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR = "SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR"

export const DELETE_REGISTRATION_PENDING_USER = "DELETE_REGISTRATION_PENDING_USER";
export const DELETE_REGISTRATION_PENDING_USER_SUCCESS = "DELETE_REGISTRATION_PENDING_USER_SUCCESS";
export const DELETE_REGISTRATION_PENDING_USER_ERROR = "DELETE_REGISTRATION_PENDING_USER_ERROR";